export default "__VITE_ASSET__D6QmZj46__"